<template>
  <div id="hress1e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHress1eIndex"
            :editEvent="editEvent"
            searchBoxAlias="hress1e" />

    <detail v-show="detailDisp"
            :descCodapp="descCodapp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :codempid="codempid"
            :descCodempid="app.currentUser.username[app.nowLang]"
            :detail="detail"
            :dropdowns="dropdowns"
            :searchIndex="searchIndex"
            :detail1Columns="columns[app.nowLang].detail1Columns"
            :detail2Columns="columns[app.nowLang].detail2Columns"
            :postDetail2Save="postDetail2Save" />
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hress1e/mutation-types'
import detail from 'components/hress1e/detail'
import moment from 'moment'

export default {
  name: 'hress1e',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      searchIndex: {
        year: moment().format('YYYY'),
        numtime: '1'
      }
    }
  },
  created () {
    this.receivedHress1eColumnsLabels()
    this.receivedHress1eDropdowns()
  },
  computed: {
    descCodapp () {
      return this.$root.$children[0].$children[0].descCodapp
    },
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRESS1E_INDEX_DISP,
      detailDisp: types.GET_HRESS1E_DETAIL_DISP,
      labels: types.GET_HRESS1E_LABELS,
      index: types.GET_HRESS1E_INDEX,
      columns: types.GET_HRESS1E_COLUMNS,
      indexSelected: types.GET_HRESS1E_INDEX_SELECTED,
      detail: types.GET_HRESS1E_DETAIL,
      dropdowns: types.GET_HRESS1E_DROPDOWNS
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'edit':
          if (this.indexSelected.kpino) {
            // if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
            //   swal({
            //     title: constLabels('warningTitle'),
            //     text: constLabels('HR1490'),
            //     confirmButtonText: constLabels('ok')
            //   })
            // }
            let searchParams = {
              p_dteyreap: this.indexSelected.dteyreap,
              p_numtime: this.indexSelected.numtime,
              p_kpino: this.indexSelected.kpino
            }
            this.receivedHress1eDetail(searchParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRESS1E_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRESS1E_PAGE,
      receivedHress1eColumnsLabels: types.RECEIVED_HRESS1E_COLUMNS_LABELS,
      receivedHress1eIndex: types.RECEIVED_HRESS1E_INDEX,
      receivedHress1eDetail: types.RECEIVED_HRESS1E_DETAIL,
      postDetail2Save: types.POST_HRESS1E_DETAIL2_SAVE,
      receivedHress1eDropdowns: types.RECEIVED_HRESS1E_DROPDOWNS
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?2782b70f